import { useLocation } from "react-router-dom";

import { skipToken } from "@reduxjs/toolkit/query";

import type { AccountDTO } from "../../common/types/AccountDTO";
import type { UserDTO } from "../../common/types/UserDTO";
import { useGetConfigQuery } from "../store/services/config";
import { useGetModulesQuery } from "../store/services/modules";
import { constructLinks, getActiveLink } from "../utils/links";

export const useModules = (user?: UserDTO, account?: AccountDTO) => {
  const { data: config } = useGetConfigQuery();
  const rootPath = config?.rootPath;
  const { pathname } = useLocation();
  const allModuleAccess = account?.properties?.allModuleAccess;
  const accountId = account?.id;

  const {
    data: modules,
    isLoading: isLoadingModules,
    isError: isModulesError,
  } = useGetModulesQuery(user ? { userId: user.id } : skipToken);

  const links = constructLinks(modules, user, accountId, allModuleAccess, rootPath);
  const activeLink = getActiveLink(links, pathname, rootPath);

  return {
    links,
    activeLink,
    hasLinks: !isLoadingModules && !!modules && !!user,
    isModulesError,
  };
};
